module.exports = __webpack_public_path__ + "img/图片14.574ee725.png";